module.exports = __webpack_public_path__ + "img/payment-method-cooperative.d1a420bb.svg";